export const uk = {
    'add-placements': {
        one: 'Для увеличения охвата добавьте поверхности формата {formats}',
        some: 'Для увеличения охвата добавьте поверхности форматов: {formats}',
        many: 'Для увеличения охвата добавьте поверхности форматов: {formats}',
        none: 'Для увеличения охвата добавьте поверхности форматов: {formats}'
    },
    'ratio-info': {
        one: '{format} для {count} креатива',
        some: '{format} для {count} креативов',
        many: '{format} для {count} креативов',
        none: '{format} для {count} креативов'
    },
    title: 'Добавьте щиты подходящих форматов',
    'title-hint': 'Рекомендация показывается, потому что нет подходящих щитов для выбранных креативов',
    'video-format': '{width}x{height} → {duration} сек.'
};
